import React, { useState, useEffect } from "react";
import { 
  Typography, Grid, Box, Button, Avatar } 
from "@mui/material"; 

import moment from "moment";

import AccessLocalStorage from "../../services/localStorage";
import {getApiUrl} from "../../services/api_service";
import ViewMedication from "./view_medication";
import {  buttonviewmore, darkcolor, pcolor, scroll } from "../../style2";


// const useStyles = makeStyles((theme) => ({
//   title: {
//     fontWeight: "bold",
//     fontSize: 14,
//     color: "#001244",
//   },
//   description: {
//     fontSize: 14,
//     color: "rgba(0, 18, 68, 0.6)",
//   },
//   date: {
//     fontFamily: "Lato",
//     fontStyle: "normal",
//     fontWeight: "normal",
//     fontSize: 12,
//     color: "rgba(0, 18, 68, 0.3)",
//   },
//   button: {
//     fontFamily: "Lato",
//     fontStyle: "normal",
//     fontWeight: "normal",
//     fontSize: 14,
//     color: "#FF767E",
//     textTransform: "unset",
//     "&:hover": {
//       background: "#FFFFFF",
//     },
//   },
//   avatar: {
//     background: "#4bc0a9",
//   },
//   scroll: {
//     overflow: "auto",
//     maxHeight: 196,
//     [theme.breakpoints.down("sm")]: {
//       maxHeight: 180,
//     },
//   },
// }));

const date = {
    fontFamily: "Lato",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: 12,
    color: "rgba(0, 18, 68, 0.3)",
  }

function Hand_List({ searchValue }) {

  const [rowsPerPage, setRowsPerPage] = useState(3);
  const rowsPerPageValue = 3;
  const [medications, setMedications] = useState([]);
  const [viewMore, setViewMore] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [open, setOpen] = useState(false);
  const [openViewMedication, setOpenViewMedication] = useState(false);
  const [anchorEls, setAnchorEls] = useState([]);
  const [anchorPosition, setAnchorPosition] = useState(null);
  const [openDeletePopup, setOpenDeletePopup] = useState(false);
  const [selectedMedication, setSelectedMedication] = useState(null);
  const ls = new AccessLocalStorage();
  
  const handleMenuClick = (event, index) => {
    const newAnchorEls = [...anchorEls];
    newAnchorEls[index] = event.currentTarget;
    setAnchorEls(newAnchorEls);
    const { left, top } = event.currentTarget.getBoundingClientRect();
    setAnchorPosition({ left, top });
  };
  const handleMenuClose = (index) => {
    const newAnchorEls = [...anchorEls];
    newAnchorEls[index] = null;
    setAnchorEls(newAnchorEls);
    setAnchorPosition(null);
  };
  const handleClickOpenViewMedication = (selectedMedication) => {
    if(!selectedMedication.isDeleted){
    setSelectedMedication(selectedMedication);
    setOpenViewMedication(true);
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickCloseDeletePopup = () => {
    setOpenDeletePopup(false);
  };
  const handleClickCloseMedication = () => {
    setOpenViewMedication(false);
    setSelectedMedication(null); // reset the selected event so the edit dialog will contain new data
  };

  useEffect(() => {
    const authTokens = localStorage.getItem("authTokens");
    let token;

    if (authTokens) {
      const parsedAuthTokens = JSON.parse(authTokens);
      token = parsedAuthTokens?.accessToken;
    }
    if (!token) {
      setError("Unauthorized. No token available.");
      setLoading(false);
      return;
    }

    fetch(`${getApiUrl()}${process.env.REACT_APP_GET_MEDICATION}/${ls.getCurrentPatientId()}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        let result = [];
        data.forEach((e) => {
          if(!e.isDeleted)
          result.push(e);
      });
      data.forEach((e) => {
        if(e.isDeleted)
        result.push(e);
    });
        //console.log(result);
        setMedications(result);
      })
      .catch((err) => {
        setError(err.message || "An error occurred.");
        setMedications([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const emptyRows =
    medications.filter((val) => {
      if (searchValue === "") {
        return val;
      } else if (
        Object.values(val)
          .join(" ")
          .toLowerCase()
          .includes(searchValue.toLowerCase())
      ) {
        return Object.values(val);
      }
    }).length === 0
      ? rowsPerPage
      : rowsPerPage -
        medications.filter((val) => {
          if (searchValue === "") {
            return val;
          } else if (Object.values(val).join(" ").toLowerCase().includes(searchValue.toLowerCase())) {
            return Object.values(val);
          }
        }).length;

  const handleViewMore = () => {
    viewMore ? setViewMore(false) : setViewMore(true);
    viewMore ? setRowsPerPage(3) : setRowsPerPage(medications.length);
  };
  return (
    <Box component="div">
      <Box paddingTop={2} />
      <Box component="div" sx={{...scroll, height:300, maxHeight:300}}>
        {medications != null && medications.length > 0 ? medications
          .filter((val) => {
            if (searchValue === "") {
              return val;
            } else if (Object.values(val).join(" ").toLowerCase().includes(searchValue.toLowerCase())) {
              return Object.values(val);
            }
          })
          .slice(0, rowsPerPage)
          .map((medication,index) => (
            <Box component="div" key={medication.id} title={medication.isDeleted ? "Archived" : ""}>
              <Grid container xs={12} sm={12} md={12} lg={12} xl={12} spacing={2} sx={{marginBottom:"15px"}}>
                <Grid item style={{fontWeight:"normal"}}>
                {medication.isDeleted ? <Avatar onClick={() => handleClickOpenViewMedication(medication)}
                   style={{cursor: "pointer",width:"50px", height:"50px", backgroundColor: "#ccc"}}  aria-label="recipe">
                    {medication.medicineName.charAt(0)}
                  </Avatar> :
                  <Avatar onClick={() => handleClickOpenViewMedication(medication)}
                   style={{cursor: "pointer",width:"50px", height:"50px", backgroundColor: pcolor}}  aria-label="recipe">
                    {medication.medicineName.charAt(0)}
                  </Avatar>}
                </Grid>
                <Grid item xs direction="column" spacing={2} onClick={() => handleClickOpenViewMedication(medication)} style={{ cursor: "pointer"}}>
                  <Grid item xs>
                    {medication.isDeleted ? <Typography title="Archived" style={{color:"#ccc"}}>
                      {medication.medicineName}
                    </Typography> : <Typography style={{color:pcolor}}>
                      {medication.medicineName}
                    </Typography>}
                    {medication.isDeleted ? <Typography  sx={{...date, color:"#ccc"}}>
                        {moment(medication.createdOn).format("DD.MM.YYYY")}
                      </Typography> :
                    <Typography  sx={{...date, color:darkcolor}}>
                        {moment(medication.createdOn).format("DD.MM.YYYY")}
                      </Typography>}
                    {/* {medication.medicationDates.map((medDate) => (
                      <Typography className={classes.date} style={{color:"#545454"}} key={medDate.id}>
                        {moment(medDate.startDate).format("DD.MM.YYYY")}
                      </Typography>
                    ))} */}
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          )) : loading ? null : <Box><Typography style={{textAlign:"center"}}>No Medications</Typography></Box>}
      </Box>
      <Box component="div" sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          {!viewMore && medications.length > rowsPerPageValue ? 
            <Button sx={buttonviewmore} onClick={handleViewMore}>Show More</Button> : null
          }
          
      </Box>
      {/* <EditEvent
        open={openViewMedication}
        handleClose={handleClickCloseMedication}
        eventType={"Medication"}
        eventData={selectedMedication}
        disabled={true}
      /> */}
      <ViewMedication open={openViewMedication} handleClose={handleClickCloseMedication} eventType={"Medication"} eventData={selectedMedication} />
    </Box>
  );
}

export default Hand_List;
